import React from 'react'
import Widget from './Widget'
import styled from '@emotion/styled'
import TableTopSection from './TableTopSection'
import { ModalButton } from './ModalButton'

const WidgetWrapper = styled.div`
  width: calc(100vw - 120px);
  padding: 40px 0;
  margin: auto;
`

const StyledWidget = styled(Widget)`
  height: calc(100vh - 160px);
`

const ButtonContainer = styled.div`
  width: 176px;
  & button:disabled {
    background: transparent linear-gradient(0deg, #f6f7f9 0%, #ffffff 100%) 0% 0% no-repeat
      padding-box;
    box-shadow: 0px 1px 1px #161d250d;
    border: 1px solid #d8dce6;
    border-radius: 4px;
    color: #3e3f42;
  }
`

const EditButtonContainer = styled.div`
  width: auto;
  margin-right: 20px;
`

const ButtonWrapper = styled.div`
  display: flex;
  align-items: center;
`

const EditButtonText = styled.p<{ linkClickDisabled: boolean | undefined }>`
  color: ${({ linkClickDisabled }) => (linkClickDisabled ? '#747578' : '#289c91')};
  font-size: 16px;
  :hover {
    cursor: pointer;
    color: #fa2d35;
  }
`

const ChildrenContainer = styled.div`
  height: calc(100vh - 228px);
  overflow: scroll;
  border-top: 1px solid var(--border-color-base);
`

type Props = {
  children?: any
  handleLinkClick: () => void
  handleSaveButton: () => void
  title: string
  saveButtonText: string
  saveButtonDisabled: boolean
  linkText?: string
  linkClickDisabled?: boolean
}

const LargeModal = ({
  children,
  handleLinkClick,
  handleSaveButton,
  title,
  saveButtonText,
  saveButtonDisabled,
  linkClickDisabled,
  linkText = 'Cancel'
}: Props) => (
  <WidgetWrapper>
    <StyledWidget>
      <TableTopSection
        title={title}
        rightSideElements={
          <ButtonWrapper>
            <EditButtonContainer>
              <EditButtonText linkClickDisabled={linkClickDisabled} onClick={handleLinkClick}>
                {linkText}
              </EditButtonText>
            </EditButtonContainer>
            <ButtonContainer>
              <ModalButton
                name={saveButtonText}
                onClick={handleSaveButton}
                disabled={saveButtonDisabled}
              />
            </ButtonContainer>
          </ButtonWrapper>
        }
        isCreateNew={true}
      />
      <ChildrenContainer>{children}</ChildrenContainer>
    </StyledWidget>
  </WidgetWrapper>
)

export default LargeModal
